/**
 * MBA Lab — the Org Alignment Workbench's 4 elements and 6 pairwise fits,
 * from the public Nadler-Tushman Congruence Model (see Content/Leadership/
 * the-congruence-model-for-organizational-alignment.md). Pure data, no
 * functions, matching readiness-dimensions.js's precedent - never read from
 * any Mercer-Delta-derived material, per the delta plan's exclusion list.
 */

export const ELEMENTS = Object.freeze([
  {
    key: 'work',
    label: 'Work',
    prompt: 'What does the work actually require, day to day?',
    helpText: 'The tasks themselves and what doing them well takes - not the org chart, the actual work.',
  },
  {
    key: 'people',
    label: 'People',
    prompt: 'Who is doing the work, and what do they need to do it well?',
    helpText: 'Skills and capacity, and what would help them perform - not a roster, a real read on fit.',
  },
  {
    key: 'formal',
    label: 'Formal structure',
    prompt: 'How is this officially organized - reporting lines, process, incentives?',
    helpText: 'The stated, written-down structure: who reports to whom, how decisions are officially made.',
  },
  {
    key: 'informal',
    label: 'Informal structure (culture)',
    prompt: "What actually happens, regardless of what's official?",
    helpText: 'Unwritten norms and real behavior patterns - what people have actually learned happens in practice.',
  },
]);

export const PAIRS = Object.freeze([
  {
    key: 'work-people',
    aKey: 'work',
    bKey: 'people',
    label: 'Work × People',
    prompt: 'Does the work genuinely fit what your people are equipped and positioned to do?',
  },
  {
    key: 'work-formal',
    aKey: 'work',
    bKey: 'formal',
    label: 'Work × Formal structure',
    prompt: 'Does the formal structure actually support how the work really gets done?',
  },
  {
    key: 'work-informal',
    aKey: 'work',
    bKey: 'informal',
    label: 'Work × Informal structure',
    prompt: 'Do real day-to-day norms help the work, or quietly undercut it?',
  },
  {
    key: 'people-formal',
    aKey: 'people',
    bKey: 'formal',
    label: 'People × Formal structure',
    prompt: "Does the formal structure - roles, incentives - actually fit who's doing the work?",
  },
  {
    key: 'people-informal',
    aKey: 'people',
    bKey: 'informal',
    label: 'People × Informal structure',
    prompt: 'Do unwritten norms support your people, or work against them?',
  },
  {
    key: 'formal-informal',
    aKey: 'formal',
    bKey: 'informal',
    label: 'Formal × Informal structure',
    prompt: 'Does what actually happens match what the formal structure says should happen?',
  },
]);
